import $ from 'jquery';


export function start() {
    addEventListener();
}

function addEventListener() {
    $(function () {
        startAnimation();
    });
}

function startAnimation() {
    $('.home-content').removeClass('hidden')
}

export default {
    start
}


// WEBPACK FOOTER //
// ./modules/index-animate.js